import styled from "@emotion/styled";
import { Box, Divider } from "@mui/material";
import { FC } from "react";
import { IInvoiceData } from "../InvoicePage";


const DetailsBox = styled(Box)(({ theme }) => ({
    width: "100%",
    margin: "0 4px",
}));


const NameBox = styled(Box)(({ theme }) => ({
    width: "100%",
    fontSize: 13,
    border: "1px solid #000000ff",
    backgroundColor: "#b8a58abe",
    textAlign: "center",
    padding: "3px 0",
    alignItems: "center",
}));


const DataBox = styled(Box)`
    font-size: 13px;
    padding: 0 4px;
    font-weight: 500;
`


interface HeaderProps {
    invoiceData: IInvoiceData;
}

const Header: FC<HeaderProps> = ({
    invoiceData
}) => {
    return (
        <Box sx={{ width: "100%", display: "flex" }}>
            <DetailsBox sx={{ width: "50%" }}>
                <NameBox>
                    Nabywca
                </NameBox>
                <DataBox>
                    {invoiceData.ordererName && <Box>{invoiceData.ordererName}</Box>}
                    {(invoiceData.ordererAddress.street || invoiceData.ordererAddress.houseNumber || invoiceData.ordererAddress.apartmentNumber || invoiceData.ordererAddress.postalCode || invoiceData.ordererAddress.city) && (
                        <Box>
                            {[invoiceData.ordererAddress.street, invoiceData.ordererAddress.houseNumber].filter(Boolean).join(" ")}
                            {invoiceData.ordererAddress.apartmentNumber ? `/${invoiceData.ordererAddress.apartmentNumber}` : ""}
                            {((invoiceData.ordererAddress.street || invoiceData.ordererAddress.houseNumber || invoiceData.ordererAddress.apartmentNumber) && (invoiceData.ordererAddress.postalCode || invoiceData.ordererAddress.city)) ? ", " : ""}
                            {[invoiceData.ordererAddress.postalCode, invoiceData.ordererAddress.city].filter(Boolean).join(" ")}
                        </Box>
                    )}
                    {invoiceData.ordererNIP && <Box>NIP: {invoiceData.ordererNIP}</Box>}
                    {invoiceData.ordererEmail && <Box>Email: {invoiceData.ordererEmail}</Box>}
                    {invoiceData.ordererPhone && <Box>Tel: {invoiceData.ordererPhone}</Box>}
                </DataBox>
                <Divider sx={{ backgroundColor: '#000000', mt: 1 }} />
            </DetailsBox>
            <DetailsBox sx={{ width: "50%" }}>
                <NameBox>
                    Sprzedawca
                </NameBox>
                <DataBox>
                    <Box>UFO Sp. z o.o.</Box>
                    <Box>Stojadła ul. Warszawska 93/95, Mińsk Mazowiecki, 05-300</Box>
                    <Box>NIP: 527-298-84-07</Box>
                </DataBox>
                <Divider sx={{ backgroundColor: '#000000', mt: 1 }} />
            </DetailsBox>
        </Box>
    );
}

export default Header;